import { useState } from 'react';
import type { GameComponentProps } from '../core/types';
import { isFixturePuzzle } from './types';

export function FixtureGame({ puzzle, disabled, onCharge, onComplete }: GameComponentProps) {
  if (!isFixturePuzzle(puzzle.payload))
    throw new Error('Fixture game received an invalid payload.');
  const [charged, setCharged] = useState(false);

  return (
    <section className="fixture-game" aria-labelledby="fixture-title">
      <p className="eyebrow">Foundation fixture</p>
      <h2 id="fixture-title">{puzzle.payload.prompt}</h2>
      <div className="fixture-card" aria-label={`${puzzle.gameId} fixture puzzle`}>
        <span className="fixture-glyph" aria-hidden="true">
          {puzzle.payload.glyph}
        </span>
        <p>
          This temporary interaction exercises completion, failure, penalties, persistence, and the
          shared run shell. It will be replaced by the real game in its milestone.
        </p>
      </div>
      <div className="button-row" aria-label="Fixture controls">
        <button
          className="button button--secondary"
          disabled={disabled || charged}
          onClick={() => {
            onCharge('fixture-hint', 5_000, 'Fixture hint');
            setCharged(true);
          }}
        >
          {charged ? 'Hint charged' : 'Test hint (+5s)'}
        </button>
        <button
          className="button"
          disabled={disabled}
          onClick={() =>
            onComplete({ kind: 'solved', baseDeltaMs: -3_000, message: 'Fixture cleared!' })
          }
        >
          Complete fixture
        </button>
        <button
          className="button button--danger"
          disabled={disabled}
          onClick={() =>
            onComplete({ kind: 'failed', baseDeltaMs: 15_000, message: 'Fixture failed.' })
          }
        >
          Fail fixture
        </button>
      </div>
    </section>
  );
}
